<template>
  <section class="bg-white">
    <div class="main-content">
      <router-view/>
    </div>
    <div class="card rounded-0 mb-0 border-right-0 border-left-0 border-bottom-0 bottom-navigation">
      <div class="card-body p-2">
        <div class="d-flex">
          <div class="flex-fill text-center" @click="activeMenu = 'home'">
            <router-link class="no-style"
                         :class="{'menu-text': activeMenu === 'home'}"
                         to="/line-liff">
              <div>
                <i class="fal fa-home-alt fa-lg"></i>
              </div>
              <span class="text-small">{{ $t('message.line_liff.home') }}</span>
            </router-link>
          </div>
          <div class="flex-fill text-center" @click="activeMenu = 'bookings'">
            <router-link class="no-style"
                         :class="{'menu-text': activeMenu === 'bookings'}"
                         to="/line-liff/bookings">
              <div>
                <i class="fal fa-calendar-alt fa-lg"></i>
              </div>
              <span class="text-small">{{ $t('message.line_liff.bookings') }}</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data () {
    return {
      activeMenu: 'home'
    }
  },
  watch: {
    $route (to, from) {
      this.checkActiveMenu(to.path)
    }
  },
  methods: {
    checkActiveMenu (routePath) {
      if (routePath.startsWith('/line-liff/bookings')) {
        this.activeMenu = 'bookings'
      } else {
        this.activeMenu = 'home'
      }
    }
  },
  mounted () {
    this.checkActiveMenu(this.$route.path)
  }
}
</script>

<style scoped>
.main-content {
  min-height: 100vh;
  padding-bottom: 3rem;
}

.bottom-navigation {
  z-index: 10;
  height: auto;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.menu-text {
  color: #00ACC1 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/lineLiff/Index.vue